import { Button, Modal } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import { useDispatch } from "react-redux";
import {
  GetAllClaimsList,
  ResubmitClaim,
  SubmitClaimIndividualMulti,
  WidthDrownDeleteClaim,
} from "../config/cliamApi";
import { toast } from "react-toastify";
const ClaimConfirmationDeleteModal = ({
  show,
  onClose,
  status,
  row,
  body,
  setOpenError,
  setResubmitBody,
  setResubmitError,
  setError,
  setPage,
  setRowsPerPage,
}) => {
  const dispatch = useDispatch();
  const handleDeleteClaim = async () => {
    const delBody = {
      claim_data: [
        {
          claimid: row?.claimfull_id,
          claim_type: row?.claim_type,
          claim_status: status,
        },
      ],
    };

    const subBody = {
      claim_data: [
        {
          claimid: row?.claimfull_id,
          claim_type: row?.claim_type,
        },
      ],
    };

    const resubmitBody = {
      claimid: row?.claimfull_id,
      claim_type: row?.claim_type,
      claim_retype:
        row?.clm_status?.toLowerCase() === "cancelled" ||
        row?.clm_status?.toLowerCase() === "invalid"
          ? "resubmitwo"
          : "resubmit",

      cncl_reason: "",
    };
    const response = await dispatch(
      status === "resubmit"
        ? ResubmitClaim(resubmitBody)
        : status === "submit"
          ? SubmitClaimIndividualMulti(subBody)
          : WidthDrownDeleteClaim(delBody),
    ).unwrap();

    if (response?.success) {
      setPage(0);
      setRowsPerPage(10);
      toast.success(response?.message_en);
      onClose();
      await dispatch(GetAllClaimsList(body)).unwrap();
    } else {
      if (response?.data?.error_code === "RE-00133") {
        const resubmitWoBody = {
          claimid: row?.claimfull_id,
          claim_type: row?.claim_type,
          claim_retype: "resubmitwo",
          cncl_reason: "",
        };
        const responseWo = await dispatch(
          ResubmitClaim(resubmitWoBody),
        ).unwrap();
        if (responseWo?.success) {
          setPage(0);
          setRowsPerPage(10);
          toast.success(responseWo?.message_en);
          onClose();
          await dispatch(GetAllClaimsList(body)).unwrap();
        } else {
          setOpenError(true);
          setError(response);
          onClose();
        }
      } else if (response?.data?.error_code !== "RE-00133") {
        setResubmitBody({
          claimid: row?.claimfull_id,
          claim_type: row?.claim_type,
          claim_retype: "resubmitwo",
          cncl_reason: "",
        });
        onClose();
        setResubmitError(true);
      } else {
        setOpenError(true);
        setError(response);
        onClose();
      }
    }
  };
  return (
    <Modal show={show} centered dialogClassName="wizard-modal" size="md">
      <Modal.Body>
        <FalconCloseButton
          onClick={onClose}
          size="sm"
          className="position-absolute top-0 end-0 me-2 mt-2"
        />
        <Flex direction="column" alignItems="center" className="mb-3">
          <h6 className="fs-8 text-capitalize text-700">
            {status === "withdrawn" ? "withdraw" : status} Claim
          </h6>
          <h6 className="fs-10 text-600 text-center">
            Are you sure you want to {status} claim
          </h6>
        </Flex>

        <hr />
        <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
          <Button variant="danger" size="sm" onClick={onClose}>
            No
          </Button>
          <Button variant="success" size="sm" onClick={handleDeleteClaim}>
            Yes
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ClaimConfirmationDeleteModal;
